//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import card from '@/components/card/card.vue';
import empty from '@/components/empty.vue';
import statusContent from '@/components/card/status.vue';
import avatars from '@/components/card/avatars.vue';
import { activity_api } from '@/api/api/user';
import { formatPath, diffAbsTime } from '@/utils/tools';
import { setting_obj } from '@/settings/setting.js';
import mgSelect from '@/components/custom/mg-select.vue';
import { checkLogin } from '@/utils/sso';
import { openReport, removeReport } from '@/utils/report';
import { isElectron } from '@/utils/constants';
import { handleUserBehaviorByType } from "@/components/subscription/subscription.js";

function cal_banner_zoom() {
  try {
    if (window) {
      const innerWidth = window.innerWidth - 64;
      if (innerWidth > 1614) {
        return 1;
      }
      return innerWidth / 1614;
    }
    return 1;
  } catch (e) {
    return 1;
  }
}

let ticking = false;

export default {
  components: {
    card,
    empty,
    statusContent,
    avatars,
    mgSelect,
  },
  data() {
    return {
      copyUrl: '',
      filterOptions: [
        {
          value: 0,
          label: '最新发布',
        },
        {
          value: 1,
          label: '当前最热',
        },
      ],
      defaultChoosed: 0,
      activityDetail: {},
      loading: false,
      page_num: 1,
      page_size: 24,
      resourceList: [],
      total: 0,
      fixed: false,
      isEmpty: false,
      zoomNum: 1,
      from_admin: false,
      isClient: false
    };
  },
  computed: {
    end_mark() {
      return this.activity_result.first_num < 0;
    },
    isEndAct() {
      return this.activity_result.act_status === '2'
    },
    disabled() {
      return this.loading || this.noMore;
    },
    emptyText() {
      return '活动进行中，快来上传你的作品吧';
    },
    noMore() {
      return this.total && this.resourceList.length >= this.total;
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    activity_result() {
      let info = { ...this.activityDetail };
      if (info.act_id !== undefined) {
        const timeObj = diffAbsTime(new Date(), info.end_time);
        info = { ...info, ...timeObj };
        info.act_detail_cover_url = formatPath(info.act_detail_cover_url, setting_obj.imageCdnPath);
        info.start_time = info.start_time.split('T')[0].replace(/-/g, '.');
        info.end_time = info.end_time.split('T')[0].replace(/-/g, '.');
        info.time_mark = `${info.start_time}-${info.end_time}`;

        info.act_status += '';
      }
      return info;
    },
    trophyList() {
      if(this.$route.query.from === 'admin'){
        return this.activityDetail.trophy_list ? this.activityDetail.trophy_list : []
      }
      return this.activityDetail.trophies ? this.activityDetail.trophies:[]
    },
    prizeStyle() {
      const  len = this.trophyList.length
      return {
        width: len > 3 ? '320px' : '438px',
      };
    },
  },
  watch: {},
  beforeCreate() {},

  created() {},
  async mounted() {
    this.isClient = isElectron();
    this.zoomNum = cal_banner_zoom();
    window.scrollTo({ top: 0 });
    if (!this.activityDetail.act_id) {
      if (this.$route.query.from === 'admin') {
        this.from_admin=true;
        const admin_params = this.$route.query.admin_params;
        if (admin_params) {
          let result_params = {};
          try {
            result_params = JSON.parse(unescape(window.atob(admin_params)));
          } catch (e) {
            console.log(e);
          }
          result_params.act_id = '';
          this.activityDetail = result_params;
        }
      } else if (this.$route.query.id) {
        await this.initSsrData();
      }
    }
    this.copyUrl = location.href;
    this.loadMoreData();
    this.$sensors.track('page_view', {
      action_position: 'activity_detail',
      active_id: this.activityDetail.act_id,
      active_name: this.activityDetail.act_name,
    });
    window.addEventListener('resize', this.resize_func);
  },
  beforeDestroy() {
    removeReport('publish');
    this.clearCondition();
    window.removeEventListener('scroll', this.scrollEvent);
    window.removeEventListener('resize', this.resize_func);
  },
  async asyncData({ app, query, redirect}) {
    if (query.from === 'admin') {
      return { isEmpty: true };
    }
    const act_id = query.id;
    try {
      const params = {
        act_id,
      };
      let activityDetail = {};
      let resourceList = [];
      let total = 0;
      const res1 = await app.$axios.$get(activity_api.detail, { params });
      if (res1.code === 'OK') {
        activityDetail = res1.data;
      }
      app.head.title = `${activityDetail.act_name}-MasterGo 社区`;
      const workParams = {
        page_num: 1,
        page_size: 24,
        sort_type: 0,
        act_id,
      };
      const res2 = await app.$axios.$get(activity_api.works_list, { params: workParams });
      if (res2.code === 'OK') {
        resourceList = res2.data || [];
        total = res2.meta.page.total;
      }
      return { activityDetail, resourceList, total, isEmpty: resourceList.length === 0 };
    } catch (e) {
      app.store.commit('err/setError', e);
      if(e.response.status === 404) return redirect('/404/activity')
      return {};
    }
  },
  methods: {
    toShare(){
      this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter0:'community_active',
        action_detail:`share`,
        action_type:'click',
        active_id:this.$route.query.id,
        active_name:this.activity_result.act_name,
      });
    },
    resize_func() {
      this.cal_zoom();
    },
    cal_zoom() {
      this.zoomNum = cal_banner_zoom();
    },
    toClass() {
       this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter0:'community_active',
        action_detail:`tutorial`,
        action_type:'click',
        active_id:this.$route.query.id,
        active_name:this.activity_result.act_name,
      });
      if (!checkLogin()) {
        return false;
      }
      handleUserBehaviorByType('activity');
      if (isElectron()) {
        window.open(this.activityDetail.course_url);
        return true;
      }
      location.href = this.activityDetail.course_url;

      return true;
    },
    async initSsrData() {
      const act_id = this.$route.query.id;
      try {
        const params = {
          act_id,
        };
        let activityDetail = {};
        let resourceList = [];
        let total = 0;
        const res1 = await this.$axios.$get(activity_api.detail, { params });
        if (res1.code === 'OK') {
          activityDetail = res1.data;
        }
        const workParams = {
          page_num: 1,
          page_size: 24,
          sort_type: 0,
          act_id,
        };
        const res2 = await this.$axios.$get(activity_api.works_list, { params: workParams });
        if (res2.code === 'OK') {
          resourceList = res2.data || [];
          total = res2.meta.page.total;
        }
        this.activityDetail = activityDetail;
        this.resourceList = resourceList;
        this.total = total;
        this.isEmpty = resourceList.length === 0;
        return { activityDetail, resourceList, total, isEmpty: resourceList.length === 0 };
      } catch (e) {
        console.log('err', e);
        return {};
      }
    },
    onCopy() {
      this.$message({
        message: '分享链接已复制，快去分享吧...',
        type: 'success',
      });
    },
    onError() {
      this.$message({
        message: '分享链接复制失败,请手动复制地址栏链接',
        type: 'error',
      });
    },
    upload_resource() {
      if (!checkLogin()) {
        return false;
      }
      openReport('publish', { act_id: this.$route.query.id, act_name: this.activity_result.act_name, type: 'active' });
      return true;
    },
    cardclick(item) {
      const routeData = this.$router.resolve({
        path: '/activity/resource',
        query: { act_id: this.$route.query.id, res_id: item.res_id },
      });
      window.open(routeData.href, '_blank');
    },
    changeFilter() {
      this.page_num = 1;
      this.initData();
    },
    scrollEvent() {
      const that = this;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
          const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
          const scrollTotal = scrollTop + clientHeight
          const offsetBottom = 50
          if (!that.noMore && !that.isEmpty && !that.loading) {
            if (scrollTotal + offsetBottom >= scrollHeight) {
              that.loadMore();
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    },
    loadMoreData() {
      if (!window) {
        return;
      }
      window.addEventListener('scroll', this.scrollEvent);
    },

    clearCondition() {
      this.page_num = 1;
      // this.resourceList = [];
    },
    loadMore() {
      if (this.noMore || this.loading) return;
      this.page_num++;
      this.initData();
    },
    async initData() {
      this.loading = true;
      this.isEmpty = false;
      const params = {
        page_num: this.page_num,
        page_size: this.page_size,
        act_id: this.$route.query.id,
        sort_type: this.defaultChoosed,
      };

      try {
        const res = await this.$axios.$get(activity_api.works_list, { params });
        const { code, data = [], meta } = res;
        if (code === 'OK') {
          this.loading = false;
          this.total = meta.page.total;
          if (this.resourceList.length && this.page_num !== 1) {
            if (data?.length) this.resourceList.push(...data);
          } else {
            this.resourceList = data || [];
          }
          if (!this.resourceList.length) {
            this.isEmpty = true;
          }
        }
      } catch (error) {
        console.warn(error);
      }
    },
  },
};
